import { createSelector } from 'reselect';
import { State } from 'reducers';
import { PolicyId, Policy } from 'types';
import { TranslateProps } from 'util/i18n';

export type HasPolicyId = {
    policyId: PolicyId | null;
};

const getPolicyId = <T extends HasPolicyId>(state: State, props: T) => props.policyId;

export const getPolicyTranslatedName = (policy: Policy, { t }: TranslateProps): string => {
    switch (policy.systemRuleId) {
        case -1: return t('Setup_Database_Policy_Lost_Camera_Connection');
        case -2: return t('6.9622.3786');
        case -3: return t('Policy_Unknown_Alarm_Event');
        case -4: return t('Policy_Manual_Alarm');
        case -5: return t('Policy_Supervision_Alarm');
        case -6: return t('Policy_Failover_Alarm');
        case -7: return t('Policy_Fallback_Alarm');
        default: return policy.name;
    }
};

export const getPolicyMap = (state: State) => state.policy.data;

export const isLoadingPolicies = (state: State) => state.policy.loading;

export const getPoliciesError = (state: State) => state.policy.error;

export const getPolicy =
    createSelector(
        getPolicyId,
        getPolicyMap,
        (policyId, policyMap) => policyMap && policyId && policyMap[policyId]
    );



// WEBPACK FOOTER //
// ./src/selectors/policySelectors.ts